module.exports = __webpack_public_path__ + "img/icontype5.8de5cd10.png";